/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import * as Sentry from "@sentry/react";

import NavBar from 'components/NavBar';
import Header from 'components/Header';
import Footer from 'components/Footer';

import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';
import { makeSelectUser, makeSelectTokenValidation, featureAllowed } from './selectors';
import { getUser } from './actions';
import { closeWidget } from 'components/PrescoringTool/actions'
import { default as PrescoringModal } from 'components/PrescoringTool/modal'
import { default as PrescoringWidget } from 'components/PrescoringTool/widget'

import { Tracking } from 'components';

class PrivateRoute extends React.Component {
  componentDidMount() {
    if(this.props.authentication && !this.props.user.hasOwnProperty('role')) {
      this.props.getUserInfo();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      this.props.closeWidget();
    }
  }

  get hasPrescoringWidget() {
    const regex = new RegExp('^\/offers\/[a-z0-9]+', 'i');
    return this.props.featureAllowed('prescoring') &&
      !location.pathname.startsWith('/quotations/')
      && location.pathname !== '/quotation/'
      && (!location.pathname || !regex.test(location.pathname))
  }

  render() {
    const {
      user,
      isTokenInvalid,
      component: Component,
      authentication,
      hasFaqSalesBot = false,
      ...rest
    } = this.props;

    if (isTokenInvalid) {
      window.location = '/login';
      return null;
    } else if (user.hasOwnProperty('termsAccepted') && !user.termsAccepted) {
      window.location = '/sso/activate';
      // console.log(user)
      return null;
    }

    if (authentication && ( user === undefined || !user.hasOwnProperty('role'))) return null;

    Sentry.setUser({ id: user.code, email: user.email });

    let name = '';
    try {
      name = (user.business_name !== null && user.business_name.length > 0 ) ? user.business_name : user.name;
    } catch (e) {
      name = 'utente';
    }

    return (
      <Route
        {...rest}
        render={props =>
          authentication === true ? (
            <div className="all-wrapper solid-bg-all">
              <PrescoringModal />
              {/*
                nel dettaglio offerta è disattivato
                perchè il feedback dato nella modale può essere differente da quello dato nello sticky price
              */}
              {this.hasPrescoringWidget &&
                <PrescoringWidget />
              }
              <Tracking
                code={user.code}
                name={name}
                email={user.email}
                roleName={user.roleName}
                groupType={user.group_type}
                creationDate={user.created_at}
                groupName={user.group_name}
                groupCode={user.group_code}
              />
              <Header
                hasFaqSalesBot={hasFaqSalesBot}
              />
              <div className="layout-w">
                <NavBar {...props} />
                <div className="content-w">
                  <div className="content-i">
                    <div className="content-box">
                      <Component {...props} />
                    </div>
                    <Footer />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Redirect
              to={{ pathname: '/login' }}
            />
          )
        }
      />
    );
  }
}

const withReducer = injectReducer({ key: 'user', reducer });
const withSaga = injectSaga({ key: 'user', saga });

export function mapDispatchToProps(dispatch) {
  return {
    getUserInfo: () => dispatch(getUser()),
    closeWidget: () => dispatch(closeWidget()),
  };
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  isTokenInvalid: makeSelectTokenValidation(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(PrivateRoute);
